import {
  REQUEST_FAILED,
  REQUEST_STARTED,
  REQUEST_SUCCEEDED,
  LOGED_OUT,
} from "../types/feedbackTypes";

const initialState = {
  loading: 0,
  error: "",
  show: "",
};

const feedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_STARTED: {
      return {
        ...state,
        loading: state.loading + 1,
        show: action.payload,
      };
    }
    case REQUEST_SUCCEEDED: {
      return {
        ...state,
        loading: state.loading - 1,
      };
    }
    case REQUEST_FAILED: {
      return {
        ...state,
        loading: 0,
        error: action.payload,
      };
    }
    case LOGED_OUT: {
      return {
        ...state,
        loading: 0,
      };
    }
    default: {
      return state;
    }
  }
};

export default feedbackReducer;
